import { constants } from "../constants/redux-constants";
import { REHYDRATE } from "redux-persist/lib/constants";
import i18n from "multilingual";
import { signOut } from "firebase/auth";
import { auth } from "firebase-setup";
import { unixDate } from "config/helpers/date_helper";

const initialState = {
  firstRender: true,
  language: "en",
  loader: false,
  theme: "light",
  page_loader: false,
  notification: [],
  isDashboardLoaded: false,
  audioLanguage: "en",
  print_watermark: true,
  editWidget: false,
  dashboard_selected_widgets: [],
  persistSessionContext: false,
  persistAgentContext: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REHYDRATE:
      action.payload?.app.language &&
        i18n.changeLanguage(action.payload?.app.language);
      return {
        ...state,
        ...(action.payload?.app || {}),
        theme: action.payload?.app.theme || "light",
        isDashboardLoaded: false,
      };
    case constants.RESET:
      signOut(auth)
        ?.then(() => {
          let tenantsList = localStorage.getItem("tenants") || "[]";
          localStorage?.clear();
          localStorage.setItem("tenants", tenantsList);
        })
        .catch((e) => {
          console.log(`some issue in firebase signout`, e);
        });
      return {
        ...initialState,
        // theme: state.theme,
      };
    case constants.CHANGE_LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    case constants.AUDIO_LANGUAGE:
      return {
        ...state,
        audioLanguage: action.payload,
      };
    case constants.PRINT_WATERMARK:
      return {
        ...state,
        print_watermark: action.payload,
      };
    case constants.APP.CHANGE_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case constants.APP.FULL_PAGE_LOADER:
      return {
        ...state,
        page_loader: action.payload,
      };
    case constants.APP.TOGGLE_LOADER:
      return {
        ...state,
        loader: action.payload,
      };
    case constants?.SET_DASHBOARD_LOADED:
      return {
        ...state,
        isDashboardLoaded: action.payload,
      };
    case constants?.APP?.GENERATE_NOTIFICATIONS:
      const isNewNotificationExists = state.notification.some(
        (item) => item?.id === action?.payload?.id
      );
      if (isNewNotificationExists) {
        return state;
      } else {
        return {
          ...state,
          notification: [action?.payload, ...state.notification],
        };
      }
    case constants?.APP?.EDIT_WIDGET:
      return {
        ...state,
        editWidget: action.payload,
      };
    case constants?.APP?.SET_DASHBOARD_SELECTED_WIDGETS:
      return {
        ...state,
        dashboard_selected_widgets: action.payload,
      };
    case constants?.APP?.DELETE_NOTIFICATIONS:
      return {
        ...state,
        notification: state?.notification?.filter(
          (notification) => notification?.addedOn != action?.payload
        ),
      };
    case constants?.APP?.READ_NOTIFICATIONS:
      return {
        ...state,
        notification: state?.notification?.map((notification) => {
          return {
            ...notification,
            isRead: true,
          };
        }),
      };
    case constants?.APP?.CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notification: [],
      };

    case constants.APP.SAVE_AGENT_CONTEXT:
      return {
        ...state,
        persistAgentContext: action.payload,
      };
    case constants.APP.SAVE_SESSION_CONTEXT:
      return {
        ...state,
        persistSessionContext: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
